import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { isEmpty, get } from 'lodash';
import {
  ApplicationName,
  FormNavigation,
  StepContainer
} from 'components/CASAForm';
import {
  AuDirectionLink,
  AuCallout,
  AuControlInput,
  AuErrorText,
  AuTable,
  AuHeading
} from 'components/DTA';
import { FormContext } from 'contexts';
import { DampReportContext } from 'contexts';
import { useFormikContext } from 'formik';
import { DampReportApplicationFormData } from 'types/forms/dampReportApplicationTypes';
import { DAMP_FORM_VALIDATION_ERROR_ALERT } from 'arnConstants';

const ReportSummaryAndDeclaration: React.FC = () => {
  const { values, submitForm, validateForm, getFieldMeta, errors } = useFormikContext<DampReportApplicationFormData>();
  const { setFormAlert, handleBack, openStepById, setOnChangeValidation } = useContext(FormContext);
  const history = useHistory();
  const declarationFieldError = get(errors, 'declaration');
  const { referenceDataResponse } = useContext(DampReportContext);


  const saveArnApplication = async () => {
    const validationErrors = await validateForm();

    if (!validationErrors || isEmpty(validationErrors)) {
      setFormAlert(null);
      setOnChangeValidation(false);
      submitForm();
    }
    else {
      setFormAlert(DAMP_FORM_VALIDATION_ERROR_ALERT);
      setOnChangeValidation(true);
    }
  };
  const reasonsForTest = referenceDataResponse?.value && referenceDataResponse?.value['DAMP_TEST_REASON'];
  const ssaaTypes = referenceDataResponse?.value && referenceDataResponse?.value['SSAA_TYPE'];
  const australiaStates = referenceDataResponse?.value && referenceDataResponse?.value['AUSTRALIAN_STATES'];
  const stateRegions = referenceDataResponse?.value && referenceDataResponse?.value['STATE_REGIONS'];
  const subjectPositiveToList = referenceDataResponse?.value && referenceDataResponse?.value['SUBSTANCE_SUBJECT_POSITIVE_TO'];
  const testingMethods = referenceDataResponse?.value && referenceDataResponse?.value['TESTING_METHOD'];
  const alcoholReadingRanges = referenceDataResponse?.value && referenceDataResponse?.value['ALCOHOL_READING'];

  const reportDetails = [
    { title: 'Permission type', value: values.permissionType },
    { title: 'Date of test', value: values.dateOfTest },
    { title: 'Reason for test', value: reasonsForTest?.find(s => s.casa_code === values.reasonForTest)?.casa_name },
    { title: 'Age range', value: values.ageRange },
    { title: 'SSAA type', value: ssaaTypes?.find(s => s.casa_code === values.ssaaType)?.casa_name },
    { title: 'State', value: australiaStates?.find(s => s.casa_code === values.state)?.casa_name },
    { title: 'Region', value: stateRegions?.find(s => s.casa_code === values.region)?.casa_name },
    { title: 'Positive to', value: subjectPositiveToList?.find(s => s.casa_code === values.positiveTo)?.casa_name },
  ];

  if (values.positiveTo === 'ALCOHOL') {
    reportDetails.push({ title: 'Alcohol reading', value: alcoholReadingRanges?.find(s => s.casa_code === values.alcoholReading)?.casa_name });
  }
  reportDetails.push({ title: 'Method of testing', value: testingMethods?.find(s => s.casa_code === values.methodOfTesting)?.casa_name });

  return (
    <>
      <ApplicationName name='DAMP Report' />
      <AuDirectionLink
        onClick={handleBack}
        text="Back"
        direction="left" />
      <StepContainer hidePreviousLink>
        <AuHeading level='2'>Review Report Details</AuHeading>
        <AuTable
          caption=''
          headers={[
            {
              key: 'title',
              width: '50'
            },
            {
              title: '',
              key: 'value'
            }
          ]}
          style={{ marginTop: '2rem' }}
          striped data={reportDetails} />

        <AuCallout title='Declaration'>
          <>
            <p>I hereby declare that the particulars set out in this application are true in every respect.
              I acknowledge that to knowingly make a false or misleading statement in this application is
              an offence against the Criminal Code Act 1995 (Cth).</p>
            <p>I am aware and accept the risk that information sent electronically may be intercepted and read during transmission, not delivered or modified.</p>
            <p>
              I have read <a href='https://www.casa.gov.au/about-us/who-we-are/about-casa/privacy-statement' target='_blank' rel='noopener noreferrer'>CASA&apos;s policy on the collection and release of information
              </a> and I authorise CASA to release information contained on this form in accordance with that policy.
            </p>
          </>
        </AuCallout>
        <AuControlInput
          name='declaration'
          id='declaration'
          type='checkbox'
          label='I agree and understand the above conditions'
          block
        />
        {declarationFieldError && <AuErrorText text={declarationFieldError} />}
        <FormNavigation nextButtonText='Submit notification' onNextAction={saveArnApplication} hidePrevious showSaveAndExit={false} />
      </StepContainer>
    </>
  );
};

export default ReportSummaryAndDeclaration;